import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import ReactPlaceholder from 'react-placeholder/lib';
import Controllers from '../../Api/Controllers';
import { PageHeader, SurfaceCard } from '../../Components/Ui'
import { useSelector } from 'react-redux';
import CustomersForm from '../Customers/CustomersForm'

const PersonalInformation = () => {
    const store = useSelector(store => store)
    const [ready, setReady] = useState(false)
    const [dataUser, setDataUser] = useState([])
    
    useEffect(() => {
        Controllers.users.get_user_information().then(res => {
            setDataUser(res.data)
            setReady(true)
        })
    }, [])

    return <>
        <PageHeader
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Información Personal"
            subtitle="Consulta tus datos de colaborador. Esta información es solo lectura."
        />
        <div className="form-row">
            <div className="col-12 col-md-4 mb-4">
                <SurfaceCard>
                    <div className="text-center">
                        <img src={store.session.file_photo_user} width="100" alt="" style={{
                            borderRadius: '100px',
                            border: '2px solid #E5E7EB'
                        }} />
                        <h5 style={{ color: '#201030', fontWeight: 700, paddingTop: 12, marginBottom: 4 }}>
                            {store.session.full_name}
                        </h5>
                        <p style={{ color: '#6B7280', margin: 0 }}>{store.session.username}</p>
                    </div>
                </SurfaceCard>
            </div>
            <div className="col-12 col-md-8">
                <ReactPlaceholder ready={ready} rows={20} showLoadingAnimation>
                    <SurfaceCard>
                        <CustomersForm data={dataUser} isModifyUser />
                    </SurfaceCard>
                </ReactPlaceholder>
            </div>
        </div>
    </>
}

export default PersonalInformation
